<template>
	<div class="tab">
		<div class="tab_item" v-for="(item ,index) in tabBarImg" :key="index" @click="switchToTab(item.path)">
			<img src="../assets/images/tabbar/1.png" v-if="index == 0 && $route.path !== item.path">
			<img src="../assets/images/tabbar/11.gif" v-if="index == 0 && $route.path === item.path">
			
			<img src="../assets/images/tabbar/2.png" v-if="index == 1 && $route.path !== item.path">
			<img src="../assets/images/tabbar/22.gif" v-if="index == 1 && $route.path === item.path">
			
			<img src="../assets/images/tabbar/3.png" v-if="index == 2 && $route.path !== item.path">
			<img src="../assets/images/tabbar/33.gif" v-if="index == 2 && $route.path === item.path">
			<img src="../assets/images/tabbar/4.png" v-if="index == 3 && $route.path !== item.path">
			<img src="../assets/images/tabbar/44.gif" v-if="index == 3 && $route.path === item.path">
			<p :class="$route.path === item.path ? 'active' : ''">{{item.title}}</p>
		</div>
	</div>
</template>


<script>
	export default {
		name: "Tabbar",
		data() {
			return {
				tabBarImg: [
					{
						path: '/home',
						title: '首页'
					},
					{
						path: '/liveCourse',
						title: '实时直播'
					},
					{
						path: '/myCourse',
						title: '我的专栏'
					},
					{
						path: '/user',
						title: '我的'
					},
				]
			}
		},
		methods: {
			switchToTab(path) {
				this.$router.replace(path);
			}
		}
	}
</script>

<style lang="less" scoped>
	.tab {
		width: 100%;
		max-width: 640px;
		height: 50px;
		height: calc(env(safe-area-inset-bottom) + 50px);
		padding-bottom: 0;
		padding-bottom: env(safe-area-inset-bottom);
		position: fixed;
		bottom: 0;
		// left: 0;
		z-index: 999;
		background: #ffffff;
		display: flex;
		border: 1px solid #F0F0F0;
		box-sizing: border-box;
		.tab_item {
			height: 100%;
			width: 33.33%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			padding: 0;

			img {
				width: 20px;
				height: 20px;
				margin: 0;
				padding: 0;
			}

			p {
				font-size: 12px;
				margin-top: 6px;
				color: #999999;
				font-weight: 700;
			}
			span{
				font-size: 22px;
				color: #999999;
			}
			.active{
				color: #E30E0E;
			}
		}
	}
</style>
